import * as React from 'react';
import FillInBlankActivity from '../fillInBlankActivities/fillInBlankActivity';
import { Match } from '../../interfaces/match';

interface AdminActivitySidebarProps {
  match: Match;
}

const AdminActivitySidebar: React.FC<AdminActivitySidebarProps> = ({ match }) => {
  return (
    <section className="section is-fullheight admin-activity-sidebar-section">
      <aside className="menu admin-activity-sidebar">
        <FillInBlankActivity isSidebar={true} match={match} />
      </aside>
    </section>
  )
}

export default AdminActivitySidebar;
